import { PostProperties } from "../types";
import image from "../img/lostGemAndrewWeatherall.jpg";

const post: PostProperties = {
  id: 33,
  title: "Andrew Weatherall - 10 Days Off, Ghent (27.07.2009)",
  content: `Andrew Weatherall (1963-2020) was a highly influential British DJ, producer, and remixer, renowned for his eclectic taste and innovative approach to music. Emerging from the vibrant London music scene in the late 1980s, Weatherall became a pivotal figure in the development of the acid house and electronic music genres. He gained widespread recognition for his remix of the track "Loaded" by Primal Scream, which helped define the sound of the early '90s and contributed to the rise of the Madchester scene.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/andrew-weatherall-10-days-off",
  category: "Lost Gem",
  translationsBg: {
    content: `Андрю Уедъръл (1963-2020) беше силно влиятелен британски диджей, продуцент и ремиксер, известен с еклектичния си вкус и иновативен подход към музиката. Излизайки от оживената лондонска музикална сцена в края на 80-те години на миналия век, Уедъръл се превърна в ключова фигура в развитието на жанровете есид хаус и електронна музика. Той получи широко признание за ремикса си на песента „Loaded“ на Primal Scream, която помогна за дефинирането на звука на началото на 90-те години и допринесе за възхода на сцената в Мадчестър.`,
  },
};

export default post;
